<template>
    <div class="row mb--4">
      <div class="col-7">
        <b-card header="Contact Information" class="shadow-none">
          <validation-observer ref="formValidator" v-slot="{ handleSubmit }">
            <b-form role="form" @submit.prevent="handleSubmit(submitCustomer)">
              <b-row class="row align-items-center h-100">
                <b-col>
                  <b-row>
                    <b-col>
                       <base-input
                        class="mb-3"
                        name="Id"
                        mode="lazy"
                        label="Id"
                        rules="required"
                        v-model="customer.key"
                      >
                      </base-input>
                      </b-col>
                    <b-col>
                      <base-input
                        class="mb-3"
                        name="First Name"
                        rules="required"
                        mode="lazy"
                        label="First Name"
                        v-model="customer.firstName"
                      >
                      </base-input>
                    </b-col>
                    <b-col>
                      <base-input
                        class="mb-3"
                        name="Last Name"
                        mode="lazy"
                        label="Last Name"
                        v-model="customer.lastName"
                      >
                      </base-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <base-input
                        class="mb-3"
                        name="e-mail"
                        rules="email"
                        mode="lazy"
                        label="Email Address"
                        v-model="customer.email"
                      >
                      </base-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <base-input-phone
                        class="mb-3"
                        name="Cell phone"
                        rules="phoneNumber"
                        mode="lazy"
                        label="Mobile Phone"
                        v-model="customer.cell"
                      >
                      </base-input-phone>

                      <b-checkbox
                        switch
                        size="sm"
                        v-model="customer.isActive"
                        label="Active"
                        >Active</b-checkbox
                      >
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <b-row>
                <b-col>
                  <b-button variant="primary" block type="submit" class="mt-3"
                    >Save Profile</b-button
                  >
                </b-col></b-row
              >
            </b-form>
          </validation-observer>
        </b-card>
      </div>
      <div class="col-5">
        <b-card header="Add Note" class="shadow-none">
          <b-textarea v-model="theNote" />
          <b-button
            @click="addNote"
            :disabled="theNote == ''"
            variant="primary"
            block
            class="mt-4"
            >Add Note</b-button
          >
        </b-card>
        <b-card header="Notes" class="shadow-none" v-if="customer.notes.length > 0">
          <div v-for="note in customer.notes" class="note">
            <div class="note-body">
              {{ note.note }}
            </div>
            <div class="triangle">
            </div>
            <div class="note-footer">
              <b>{{ note.userName }}</b><br />
              {{ note.date | moment("MM/DD/YYYY") }} {{ note.date | moment("hh:mm A") }}
            </div>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: { customerId: null },
  data() {
    return {
      theNote: null,
      customer: null,
    };
  },
  methods: {
    async submitCustomer() {
      var self = this;

      var response = await self.$client.post(
        "/api/customer/update",
        self.customer
      );
      if (response.data.isSuccess) {
        self.$emitter.emit("success", {
          title: "Saved",
          message: "Customer Saved",
        });

        this.$emit("customer-saved", self.customer);
      }
    },

    async addNote() {
      let r = await this.$client.post("/api/customer/addNote", {
        note: this.theNote,
        customerId: this.customer.id,
      });
      if (r.data.isSuccess) {
        this.customer.notes = r.data.value.notes;
        this.$emitter.emit("success", { message: "Note added." });
        this.theNote = "";
      }
    },
  },
  async created() {
    let r = await this.$client.get(
      "/api/customer/getCustomerEditQuery?customerId=" + this.customerId
    );
    if (r.data.isSuccess) {
      this.customer = r.data.value;
    }
  },
};
</script>

